var React = require('react');

function DropdownIconActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 8L8.68293 2L1 8","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"}));
}

DropdownIconActive.defaultProps = {"width":"17","height":"9","viewBox":"0 0 17 9","fill":"none"};

module.exports = DropdownIconActive;

DropdownIconActive.default = DropdownIconActive;
